
import { Injectable } from '@angular/core';
import { AppConfigurationClient } from "@azure/app-configuration";
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  private connectionString: string = environment.azureFeatureEndPoint;
  private client: AppConfigurationClient;

  constructor() {
    this.client = new AppConfigurationClient(this.connectionString);
  }

  public async getAccountingFirmFeatureFlag(key: string): Promise<boolean> {
    const response = await this.client.getConfigurationSetting({ key: `.appconfig.featureflag/${key}` }).then(response => {
      return { flag: response };
    }).catch(error => {
      /* incase of any error flag as null. */
      return { flag: null };
    });

    const flag = response.flag;

    if (flag && flag?.value) {
      const result = JSON.parse(flag.value);

      /* check if the entire flag is enabled or disabled */
      if (result.enabled) {

        /* check if any filters are there */
        if (result?.conditions?.client_filters?.length) {
          const isFirmFiltered = result.enabled && result.conditions.client_filters.find(filter => filter.name === 'AccountingFirmId')?.parameters[localStorage.getItem("AccountFirmId")];

          /* check if user's AccountingFirmId filter is there */
          if (isFirmFiltered !== undefined) {
            /* and firm is added. If it the firm's value is '1', only then the feature is enabled. */
            return isFirmFiltered === 1;
          } else {
            /* and firm is not added in the filter, then feature is always false for the firm */
            return false;
          }
        } else {
          /* return flag level enabled or disabled */
          return result.enabled;
        }
      } else {
        /* return flag level enabled or disabled */
        return result.enabled
      }
    } else {
      /* incase of any error or the case when flag is deleted in the future, the endpoint will return error, that time return true always. */
      return true;
    }

  }
}
